export default function ensureArray<T>(value: T): T extends any[] ? T : T[]{
  // @ts-ignore
  return Array.isArray(value) ? value : [value]
}
